import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { endPoints } from "../../services/apiEndPoints";
import apiService from "../../services/apiService";
function Projects() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await apiService.getData(endPoints.projectList);

        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
      </Container>
      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        {loading ? (
          <div className="spinner-border text-primary" role="status"></div>
        ) : data?.data?.length > 0 ? (
          data?.data?.map((item, index) => {
            return (
              <Col md={4} className="project-card" key={index}>
                <ProjectCard
                  imgPath={item?.imgPath}
                  isBlog={item?.isBlog}
                  title={item?.title}
                  description={item?.description}
                  ghLink={item?.ghLink}
                  demoLink={item?.demoLink}
                />
              </Col>
            );
          })
        ) : (
          <h1 style={{ height: "100vh", color: "purple" }}>No Data Found</h1>
        )}
      </Row>
    </Container>
  );
}

export default Projects;
